import React from "react";
import "./loader.css";

const Loader = ({ className }) => {
  return (
    <div className={`krunk-flex krunk-items-center krunk-justify-start krunk-w-full ${className}`}>
      <div className="krunk-flex krunk-flex-col krunk-items-center krunk-justify-center krunk-rounded-lg krunk-rounded-tl-none krunk-bg-headercolor krunk-p-3" style={{ width: '50px', height: '40px' }}>
        <div className="krunk-loader-dots krunk-relative krunk-block krunk-h-3" style={{ width: '34px' }}>
          <div className="krunk-absolute krunk-top-0 krunk-mt-1 krunk-h-2 krunk-w-2 krunk-rounded-full krunk-bg-primary1"></div>
          <div className="krunk-absolute krunk-top-0 krunk-mt-1 krunk-h-2 krunk-w-2 krunk-rounded-full krunk-bg-headertextcolor"></div>
          <div className="krunk-absolute krunk-top-0 krunk-mt-1 krunk-h-2 krunk-w-2 krunk-rounded-full krunk-bg-primary1"></div>
        </div>
      </div>
    </div>
  );
};


export default Loader;
